var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseParagraph',{staticClass:"timestamp",attrs:{"size":_vm.ParagraphSize.Small}},[_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.date))]),_vm._v(" "+_vm._s(_vm.$t('at'))+" "+_vm._s(_vm.time)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }